module.exports = __webpack_public_path__ + "static/media/moraine-30.35200fb1.jpg";